<!-- eslint-disable vue/require-v-for-key -->
<template>
  <b-modal
    id="user-modal"
    ref="user-modal"
    :title="$store.getters['authorization/isAdministrator'] || $store.getters['authorization/isApproverAdm'] ? $t('title.userModalAdministrator') : $t('title.userModal')"
    size="xl"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    :ok-title="$t('control.button.save')"
    :cancel-title="$t('control.button.cancel')"
    :cancel-disabled="cancelState()"
    :ok-disabled="disableOk"
    @ok="onSubmit"
    @cancel="resetForm"
  >
    <b-form>
      <b-tabs
        content-class="mt-2"
        active-nav-item-class="font-weight-bold text-danger"
        active-tab-class="font-weight-bold text-danger"
        card
      >
        <b-tab :title="$t('control.tabs.generalData')">
          <div class="row">
            <div :class="form.volunteer ? 'col-md-8' : 'col-md-12'">
              <b-card border-variant="primary">
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group
                      :label="$t('control.label.person.lastName')"
                      label-for="lastName"
                      label-class="font-weight-normal text-secondary"
                    >
                      <b-form-input
                        id="lastName"
                        v-model="$v.form.lastName.$model"
                        :state="validateState('lastName')"
                        :disabled="!needVerification && !($store.getters['authorization/isAdministrator'] || $store.getters['authorization/isApproverAdm'])"
                      />
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group
                      :label="$t('control.label.person.firstName')"
                      label-for="firstName"
                      label-class="font-weight-normal text-secondary"
                    >
                      <b-form-input
                        id="firstName"
                        v-model="$v.form.firstName.$model"
                        :state="validateState('firstName')"
                        :disabled="!needVerification && !($store.getters['authorization/isAdministrator'] || $store.getters['authorization/isApproverAdm'])"
                      />
                    </b-form-group>
                  </div>
                  <div class="col-md-7">
                    <b-form-group
                      :label="$t('control.label.person.street')"
                      label-for="street"
                      label-class="font-weight-normal text-secondary"
                    >
                      <b-form-input
                        id="street"
                        v-model="$v.form.street.$model"
                        :state="validateState('street')"
                      />
                    </b-form-group>
                  </div>
                  <div class="col-md-2">
                    <b-form-group
                      :label="$t('control.label.person.number')"
                      label-for="number"
                      label-class="font-weight-normal text-secondary"
                    >
                      <b-form-input
                        id="number"
                        v-model="$v.form.number.$model"
                        :state="validateState('number')"
                      />
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group
                      :label="$t('control.label.person.poBox')"
                      label-for="poBox"
                      label-class="font-weight-normal text-secondary"
                    >
                      <b-form-input
                        id="poBox"
                        v-model="$v.form.poBox.$model"
                        :state="validateState('poBox')"
                      />
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group
                      :label="$t('control.label.person.zip')"
                      label-for="zip"
                      label-class="font-weight-normal text-secondary"
                    >
                      <b-form-input
                        id="zip"
                        v-model="$v.form.zip.$model"
                        :state="validateState('zip')"
                      />
                    </b-form-group>
                  </div>
                  <div class="col-md-9">
                    <b-form-group
                      :label="$t('control.label.person.city')"
                      label-for="city"
                      label-class="font-weight-normal text-secondary"
                    >
                      <b-form-input
                        id="city"
                        v-model="$v.form.city.$model"
                        :state="validateState('city')"
                      />
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group
                      :label="$t('control.label.person.country')"
                      label-for="country"
                      label-class="font-weight-normal text-secondary"
                    >
                      <b-form-select
                        id="country"
                        v-model="$v.form.isoCountryCode.$model"
                        :options="$t('countries')"
                        value-field="isoCode"
                        text-field="name"
                        :state="validateState('isoCountryCode')"
                        @change="setCountry"
                      >
                        <template #first>
                          <b-form-select-option
                            :value="null"
                            disabled
                          >
                            -- {{ $t('control.option.country') }} --
                          </b-form-select-option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    &nbsp;
                  </div>
                  <div class="col-md-6">
                    <b-form-group
                      :label="$t('control.label.person.phone')"
                      label-for="phone"
                      label-class="font-weight-normal text-secondary"
                    >
                      <b-form-input
                        id="phone"
                        v-model="$v.form.phone.$model"
                        v-mask="['(###) ## ## ##', '(####) ## ## ##', '(###) ### ## ## ##', '(##) ### ## ## ##', '(##) ## ## ## ##']"
                        masked="false"
                        :state="validateState('phone')"
                      />
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group
                      :label="$t('control.label.person.mobile')"
                      label-for="mobile"
                      label-class="font-weight-normal text-secondary"
                    >
                      <b-form-input
                        id="mobile"
                        v-model="$v.form.mobile.$model"
                        v-mask="['(###) ## ## ##', '(####) ## ## ##', '(###) ### ## ## ##', '(##) ### ## ## ##', '(##) ## ## ## ##']"
                        masked
                        :state="validateState('mobile')"
                      />
                    </b-form-group>
                  </div>
                  <div class="col-md-12">
                    <b-form-group
                      :label="$t('control.label.person.email')"
                      label-for="email"
                      label-class="font-weight-normal text-secondary"
                    >
                      <b-form-input
                        id="email"
                        v-model="$v.form.email.$model"
                        :state="validateState('email')"
                      />
                    </b-form-group>
                  </div>
                </div>
              </b-card>
            </div>
            <div
              v-if="form.volunteer"
              class="col-md-4"
            >
              <b-card border-variant="primary">
                <div class="row">
                  <div class="col-md-12">
                    <b-form-group
                      :label="$t('control.label.person.expenseType')"
                      label-for="expenseType"
                      label-class="font-weight-normal text-secondary"
                    >
                      <b-form-select
                        id="expenseType"
                        v-model="$v.form.expenseType.$model"
                        :options="expenseTypes"
                        value-field="id"
                        text-field="title"
                        :state="validateState('expenseType')"
                        :disabled="!needVerification && !($store.getters['authorization/isAdministrator'] || $store.getters['authorization/isApproverAdm'])"
                      >
                        <template #first>
                          <b-form-select-option
                            :value="null"
                            disabled
                          >
                            -- {{ $t('control.label.person.selectExpenseType') }} --
                          </b-form-select-option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                  </div>
                  <div class="col-md-12">
                    <b-form-group
                      :label="$t('control.label.person.birthdate')"
                      label-for="birthdate"
                      label-class="font-weight-normal text-secondary"
                    >
                      <b-form-datepicker
                        id="birthdate"
                        v-model="$v.form.birthdate.$model"
                        v-bind="$t('control.label.calendar')"
                        :state="validateState('birthdate')"
                        locale="fr-BE"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        :start-weekday="1"
                        :show-decade-nav="true"
                        :hide-header="true"
                        :max="max"
                        :disabled="!needVerification && !($store.getters['authorization/isAdministrator'] || $store.getters['authorization/isApproverAdm'])"
                      />
                    </b-form-group>
                  </div>
                  <div class="col-md-9">
                    <b-form-group
                      :label="$t('control.label.person.nationalNumber')"
                      label-for="nationalNumber"
                      label-class="font-weight-normal text-secondary"
                    >
                      <b-form-input
                        id="nationalNumber"
                        v-model="$v.form.nationalNumber.$model"
                        v-mask="'##.##.##-###.##'"
                        :state="validateState('nationalNumber')"
                        :disabled="!needVerification && !($store.getters['authorization/isAdministrator'] || $store.getters['authorization/isApproverAdm'])"
                      />
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    &nbsp;
                  </div>
                  <div class="col-md-12">
                    <b-form-group
                      :label="$t('control.label.person.bankAccount')"
                      label-for="bankAccount"
                      label-class="font-weight-normal text-secondary"
                    >
                      <b-form-input
                        id="bankAccount"
                        v-model="$v.form.bankAccount.$model"
                        v-mask="['AA## XXXX XXXX XXXX', 'AA## XXXX XXXX XXXX XXXX', 'AA## XXXX XXXX XXXX XXXX XX', 'AA## XXXX XXXX XXXX XXXX XXXX XXX']"
                        :state="validateState('bankAccount')"
                      />
                    </b-form-group>
                  </div>
                </div>
              </b-card>
            </div>
          </div>
        </b-tab>
        <b-tab
          v-if="$store.getters['authorization/isAdministrator'] || $store.getters['authorization/isApproverAdm']"
          :title="$t('control.tabs.entities')"
        >
          <div class="col-md-12">
            <b-card
              border-variant="primary"
            >
              <div class="row">
                <div class="col-md-6">
                  <b-card
                    no-body
                    header="Entities"
                    header-bg-variant="primary"
                    header-text-variant="white"
                    border-variant="secondary"
                    text-variant="secondary"
                  >
                    <draggable
                      class="list-group flush"
                      :list="filteredEntities"
                      group="entities"
                      style="max-height:450px;overflow:auto;"
                    >
                      <div
                        v-for="(element) in filteredEntities"
                        :key="element.id"
                        class="list-group-item"
                      >
                        {{ element.name }}
                      </div>
                    </draggable>
                  </b-card>
                </div>
                <div class="col-md-6">
                  <b-card
                    no-body
                    header="Selected Entities"
                    header-bg-variant="primary"
                    header-text-variant="white"
                    border-variant="secondary"
                    text-variant="secondary"
                  >
                    <draggable
                      class="list-group"
                      :list="selectedEntities"
                      group="entities"
                      style="max-height:450px;overflow:auto;"
                    >
                      <div
                        v-for="(element) in selectedEntities"
                        :key="element.id"
                        class="list-group-item"
                      >
                        {{ element.name }}
                      </div>
                    </draggable>
                  </b-card>
                </div>
              </div>
            </b-card>`
          </div>
        </b-tab>
        <b-tab
          v-if="$store.getters['authorization/isAdministrator'] || $store.getters['authorization/isApproverAdm']"
          :title="$t('control.tabs.roles')"
        >
          <div class="col-md-12">
            <b-card
              border-variant="primary"
            >
              <div class="row">
                <div class="col-md-6">
                  <b-card
                    no-body
                    header="Roles"
                    header-bg-variant="primary"
                    header-text-variant="white"
                    border-variant="secondary"
                    text-variant="secondary"
                  >
                    <draggable
                      class="list-group flush"
                      :list="filteredRoles"
                      group="roles"
                      style="max-height:450px;overflow:auto;"
                    >
                      <div
                        v-for="(element) in filteredRoles"
                        :key="element.id"
                        class="list-group-item"
                      >
                        {{ element.name }}
                      </div>
                    </draggable>
                  </b-card>
                </div>
                <div class="col-md-6">
                  <b-card
                    no-body
                    header="Selected Roles"
                    header-bg-variant="primary"
                    header-text-variant="white"
                    border-variant="secondary"
                    text-variant="secondary"
                  >
                    <draggable
                      class="list-group"
                      :list="selectedRoles"
                      group="roles"
                      style="max-height:450px;overflow:auto;"
                    >
                      <div
                        v-for="(element) in selectedRoles"
                        :key="element.id"
                        class="list-group-item"
                      >
                        {{ element.name }}
                      </div>
                    </draggable>
                  </b-card>
                </div>
              </div>
            </b-card>`
          </div>
        </b-tab>
        <b-tab
          v-if="$store.getters['authorization/isAdministrator'] || $store.getters['authorization/isApproverAdm']"
          :title="$t('control.tabs.misc')"
        >
          <div class="row">
            <div class="col-md-3">
              <b-card
                no-body
                header="Informations"
                header-bg-variant="primary"
                header-text-variant="white"
                border-variant="secondary"
                text-variant="secondary"
              >
                <div class="row">
                  <div class="col-md-9 m-3">
                    <b-form-group
                      :label="$t('control.label.person.created')"
                      label-for="created"
                      label-class="font-weight-normal text-secondary"
                    >
                      <b-form-input
                        id="created"
                        :value="formatDate($v.form.created.$model)"
                        disabled
                      />
                    </b-form-group>
                    <b-form-group
                      :label="$t('control.label.person.modified')"
                      label-for="modified"
                      label-class="font-weight-normal text-secondary"
                    >
                      <b-form-input
                        id="modified"
                        :value="formatDate($v.form.modified.$model)"
                        disabled
                      />
                    </b-form-group>
                  </div>
                </div>
              </b-card>
            </div>
            <div class="col-md-4">
              <b-card
                no-body
                header="Options"
                header-bg-variant="primary"
                header-text-variant="white"
                border-variant="secondary"
                text-variant="secondary"
              >
                <div class="row">
                  <div class="col-md-9 m-3">
                    <b-form-checkbox
                      id="volunteer"
                      v-model="$v.form.volunteer.$model"
                      button-variant="primary"
                      :state="validateState('volunteer')"
                    >
                      {{ $t('control.label.person.isVolunteer') }}
                    </b-form-checkbox>
                    <b-form-checkbox
                      id="needVerification"
                      v-model="$v.form.needVerification.$model"
                      button-variant="primary"
                      :state="validateState('needVerification')"
                    >
                      {{ $t('control.label.person.needVerification') }}
                    </b-form-checkbox>
                    <b-form-checkbox
                      id="isOver"
                      v-model="$v.form.isOver.$model"
                      button-variant="primary"
                      :state="validateState('isOver')"
                    >
                      {{ $t('control.label.person.isOver') }}
                    </b-form-checkbox>
                    <b-form-checkbox
                      id="exceedTotalKm"
                      v-model="$v.form.exceedTotalKm.$model"
                      button-variant="primary"
                      :state="validateState('exceedTotalKm')"
                    >
                      {{ $t('control.label.person.exceedTotalKm') }}
                    </b-form-checkbox>
                    <b-form-checkbox
                      id="exceedFeeCap"
                      v-model="$v.form.exceedFeeCap.$model"
                      button-variant="primary"
                      :state="validateState('exceedFeeCap')"
                    >
                      {{ $t('control.label.person.exceedFeeCap') }}
                    </b-form-checkbox>
                  </div>
                </div>
              </b-card>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </b-form>
  </b-modal>
</template>

<script>
import moment from 'moment';
import draggable from 'vuedraggable';
import { masked, mask } from 'vue-the-mask';
import { validationMixin } from 'vuelidate';
import {
  required, email, requiredIf, minLength, maxLength, helpers,
} from 'vuelidate/lib/validators';
import people from '../services/People';
import parameters from '../services/Parameters';
import roles from '../services/Roles';
import entities from '../services/Entities';

function calculateNationalNumber(value) {
  if (value == null) return false;
  let number = value.replaceAll('-', '').replaceAll('.', '');
  if (!number) return false;
  number = number.substr(0, 11);
  if (!/\d{11}/.test(number)) return false;
  let toControl = number.substr(0, 9);
  const control = number.substr(9, 2);

  const date = number.substr(0, 6);
  const dateYear = parseInt(date.substr(0, 2), 10);
  const dateMonth = parseInt(date.substr(2, 2), 10);
  const dateDay = parseInt(date.substr(4, 2), 10);
  const todayYear = parseInt(new Date().getFullYear().toString().substr(2, 2), 10);

  if (dateMonth < 1 || dateMonth > 12 || dateDay < 1 || dateDay > 31) return false;

  if (dateYear < todayYear) toControl = `2${toControl.toString()}`;

  toControl = parseInt(toControl, 10);
  let modulo = 97 - (toControl % 97);
  modulo = Math.floor(modulo);
  modulo = modulo < 10 ? `0${modulo}` : `${modulo}`;

  return control === modulo;
}

const nationalNumberCheck = (value) => !helpers.req(value) || calculateNationalNumber(value);

function mod97(string) {
  let checksum = string.slice(0, 2);
  let fragment;
  for (let offset = 2; offset < string.length; offset += 7) {
    fragment = String(checksum) + string.substring(offset, offset + 7);
    checksum = parseInt(fragment, 10) % 97;
  }
  return checksum;
}
/*
 * Returns 1 if the IBAN is valid
 * Returns FALSE if the IBAN's length is not as should be (for CY the IBAN Should be 28 chars long starting with CY )
 * Returns any other number (checksum) when the IBAN is invalid (check digits do not match)
 */
function isValidIBANNumber(input) {
  const CODE_LENGTHS = {
    AD: 24,
    AE: 23,
    AT: 20,
    AZ: 28,
    BA: 20,
    BE: 16,
    BG: 22,
    BH: 22,
    BR: 29,
    CH: 21,
    CR: 21,
    CY: 28,
    CZ: 24,
    DE: 22,
    DK: 18,
    DO: 28,
    EE: 20,
    ES: 24,
    FI: 18,
    FO: 18,
    FR: 27,
    GB: 22,
    GI: 23,
    GL: 18,
    GR: 27,
    GT: 28,
    HR: 21,
    HU: 28,
    IE: 22,
    IL: 23,
    IS: 26,
    IT: 27,
    JO: 30,
    KW: 30,
    KZ: 20,
    LB: 28,
    LI: 21,
    LT: 20,
    LU: 20,
    LV: 21,
    MC: 27,
    MD: 24,
    ME: 22,
    MK: 19,
    MR: 27,
    MT: 31,
    MU: 30,
    NL: 18,
    NO: 15,
    PK: 24,
    PL: 28,
    PS: 29,
    PT: 25,
    QA: 29,
    RO: 24,
    RS: 22,
    SA: 24,
    SE: 24,
    SI: 19,
    SK: 24,
    SM: 27,
    TN: 24,
    TR: 26,
    AL: 28,
    BY: 28,
    EG: 29,
    GE: 22,
    IQ: 23,
    LC: 32,
    SC: 31,
    ST: 25,
    SV: 28,
    TL: 23,
    UA: 29,
    VA: 22,
    VG: 24,
    XK: 20,
  };
  const iban = String(input).toUpperCase().replace(/[^A-Z0-9]/g, ''); // keep only alphanumeric characters
  const code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/); // match and capture (1) the country code, (2) the check digits, and (3) the rest
  if (!code || iban.length !== CODE_LENGTHS[code[1]]) return false;
  // rearrange country code and check digits, and convert chars to ints
  const digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, (letter) => letter.charCodeAt(0) - 55);
  return Number(mod97(digits)) === 1;
}

const bankAccountCheck = (value) => !helpers.req(value) || isValidIBANNumber(value);

export default {
  components: {
    draggable,
  },
  directives: { mask, masked },
  mixins: [validationMixin],
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const maxDate = new Date(today);
    maxDate.setFullYear(maxDate.getFullYear() - 16);
    return {
      max: maxDate,
      expenseTypes: null,
      entities: null,
      selectedEntities: this.$store.getters['authorization/data'].entities,
      roles: null,
      selectedRoles: this.$store.getters['authorization/data'].personRoles.map((elem) => ({ id: elem.role.id, name: elem.role.name, key: elem.role.key })),
      disableOk: false,
      form: {
        id: this.$store.getters['authorization/data'].id,
        domain: this.$store.getters['authorization/data'].domain,
        login: this.$store.getters['authorization/data'].login,
        lastName: this.$store.getters['authorization/data'].lastName,
        firstName: this.$store.getters['authorization/data'].firstName,
        street: this.$store.getters['authorization/data'].street,
        number: this.$store.getters['authorization/data'].number,
        poBox: this.$store.getters['authorization/data'].poBox,
        zip: this.$store.getters['authorization/data'].zip,
        city: this.$store.getters['authorization/data'].city,
        isoCountryCode: this.$store.getters['authorization/data'].isoCountryCode,
        country: this.$store.getters['authorization/data'].country,
        phone: this.$store.getters['authorization/data'].phone,
        mobile: this.$store.getters['authorization/data'].mobile,
        email: this.$store.getters['authorization/data'].email,
        birthdate: this.$store.getters['authorization/data'].birthdate,
        expenseType: this.$store.getters['authorization/data'].expenseType,
        expenseTypeNavigation: this.$store.getters['authorization/data'].expenseTypeNavigation,
        nationalNumber: this.$store.getters['authorization/data'].nationalNumber,
        bankAccount: this.$store.getters['authorization/data'].bankAccount,
        created: this.$store.getters['authorization/data'].created,
        volunteer: this.$store.getters['authorization/data'].volunteer,
        isOver: this.$store.getters['authorization/data'].isOver,
        needVerification: this.$store.getters['authorization/data'].needVerification,
        exceedTotalKm: this.$store.getters['authorization/data'].exceedTotalKm,
        exceedFeeCap: this.$store.getters['authorization/data'].exceedFeeCap,
        modified: this.$store.getters['authorization/data'].modified,
      },
      needVerification: this.$store.getters['authorization/data'].needVerification,
      selected: [], // Must be an array reference!
    };
  },
  computed: {
    filteredEntities() {
      if (this.entities == null || this.selectedEntities == null) return [];
      return this.entities.filter((item) => !this.selectedEntities.find((se) => Number(se.id) === Number(item.id)));
    },
    filteredRoles() {
      if (this.roles == null || this.selectedRoles == null) return [];
      return this.roles.filter((item) => !this.selectedRoles.find((sr) => Number(sr.id) === Number(item.id)));
    },
  },
  mounted() {
    this.getExpenseTypes();
    this.getDates();
    if (this.$store.getters['authorization/isAdministrator'] || this.$store.getters['authorization/isApproverAdm']) {
      this.getEntities();
      this.getRoles();
    }
    this.$root.$on('updateUserModal', (user) => {
      this.update(user);
    });
  },
  validations: {
    form: {
      lastName: {
        required,
      },
      firstName: {
        required,
      },
      street: {
        required,
      },
      number: {
        required,
      },
      poBox: {
      },
      zip: {
        required,
      },
      city: {
        required,
      },
      isoCountryCode: {
        required,
      },
      country: {
        required: requiredIf((form) => form.isoCountryCode === ''),
      },
      phone: {
        required: requiredIf((form) => form.mobile === ''),
      },
      mobile: {
        required: requiredIf((form) => form.phone === ''),
      },
      email: {
        required,
        email,
      },
      expenseType: {
        required: requiredIf((form) => form.volunteer),
      },
      birthdate: {
        required: requiredIf((form) => form.volunteer),
      },
      nationalNumber: {
        required: requiredIf((form) => form.volunteer),
        minLength: minLength(15),
        maxLength: maxLength(15),
        nationalNumberCheck,
      },
      bankAccount: {
        required: requiredIf((form) => form.volunteer),
        minLength: minLength(19),
        maxLength: maxLength(33),
        bankAccountCheck,
      },
      volunteer: {},
      isOver: {},
      needVerification: {},
      exceedTotalKm: {},
      exceedFeeCap: {},
      created: {},
      modified: {},
    },
  },
  methods: {
    checkUserState() {
      if (this.$store.getters['authorization/isAdministrator'] || this.$store.getters['authorization/isApproverAdm']) return false;
      if (this.needVerification) return false;
      return true;
    },
    cancelState() {
      if (this.$store.getters['authorization/isAdministrator'] || this.$store.getters['authorization/isApproverAdm']) return false;
      if (this.needVerification) return true;
      return false;
    },
    formatDate(value) {
      if (value != null) return moment(value).format('DD/MM/YYYY HH:mm');
      return '';
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      if (!this.$store.getters['authorization/isAdministrator'] || this.$store.getters['authorization/isApproverAdm']) return;
      this.selectedRoles = [];
      this.selectedEntities = [];
      this.form = {
        id: null,
        domain: null,
        login: null,
        lastName: null,
        firstName: null,
        street: null,
        number: null,
        poBox: null,
        zip: null,
        city: null,
        isoCountryCode: null,
        country: null,
        phone: null,
        mobile: null,
        email: null,
        birthdate: null,
        expenseType: null,
        nationalNumber: null,
        bankAccount: null,
        created: null,
        volunteer: false,
        isOver: false,
        needVerification: false,
        exceedTotalKm: false,
        exceedFeeCap: false,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit(bvModalEvent) {
      this.disableOk = true;
      bvModalEvent.preventDefault();
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        this.disableOk = false;
        // eslint-disable-next-line no-console
        console.log(this.$v.form.$anyError);
        return;
      }
      if (this.needVerification && (Number(this.$store.getters['authorization/data'].id) === Number(this.form.id))) {
        const h = this.$createElement;
        const body = h('div', { domProps: { innerHTML: this.$t('message.saveUser.body') } });
        this.$bvModal.msgBoxConfirm(body, {
          title: this.$t('message.saveUser.title'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'primary',
          okTitle: this.$t('control.button.yes'),
          cancelTitle: this.$t('control.button.cancel'),
          footerClass: 'p-2',
          hideHeaderClose: true,
          centered: true,
        })
          .then(async (value) => {
            if (value) {
              this.saveUser();
            }
          })
          .catch(() => false);
      } else this.saveUser();
    },
    async saveUser() {
      this.$nextTick(async () => {
        people.baseUrl = this.$store.state.settings.apiBaseUrl;
        if (this.$store.getters['authorization/data'] != null) people.userId = this.$store.getters['authorization/data'].id;
        if (!this.form.volunteer) {
          this.form.bankAccount = '-';
          this.form.nationalNumber = '-';
          const result = await parameters.getParameter('FLAT_FEE');
          if (result[1] != null) this.form.expenseType = result[1].id;
        }
        const result = await people.putPerson(this.form.id, this.form);
        if (result[1] != null) {
          if (this.$store.getters['authorization/isAdministrator'] || this.$store.getters['authorization/isApproverAdm']) {
            await people.saveEntities(this.form.id, this.selectedEntities);
            await people.saveRoles(this.form.id, this.selectedRoles);
            this.$root.$emit('forceUpdateUsers');
          }
          if (Number(this.$store.getters['authorization/data'].id) === Number(result[1].id)) {
            this.$store.commit('authorization/updateUserData', result[1]);
            this.needVerification = result[1].needVerification;
          }
        }
        this.$root.$emit('forceUpdateExpenses');
        this.$root.$emit('forceUpdateDashboard');
        this.$bvModal.hide('user-modal');
        this.disableOk = false;
        this.resetForm();
      });
    },
    setCountry(value) {
      if (String(value) !== null) {
        const countries = this.$t('countries');
        this.form.country = countries.find((c) => String(c.isoCode) === String(value)).name;
      }
    },
    async getExpenseTypes() {
      parameters.baseUrl = this.$store.state.settings.apiBaseUrl;
      const result = await parameters.getFromCategory('EXPENSE_TYPES');
      this.$nextTick(() => {
        // eslint-disable-next-line prefer-destructuring
        this.expenseTypes = result[1];
      });
    },
    async getEntities() {
      entities.baseUrl = this.$store.state.settings.apiBaseUrl;
      if (this.$store.getters['authorization/data'] != null) entities.userId = this.$store.getters['authorization/data'].id;
      const result = await entities.getEntities();
      this.$nextTick(() => {
        // eslint-disable-next-line prefer-destructuring
        this.entities = result[1];
      });
    },
    async getRoles() {
      roles.baseUrl = this.$store.state.settings.apiBaseUrl;
      if (this.$store.getters['authorization/data'] != null) roles.userId = this.$store.getters['authorization/data'].id;
      const result = await roles.get();
      this.$nextTick(() => {
        // eslint-disable-next-line prefer-destructuring
        this.roles = result[1];
      });
    },
    async getPersonEntities(id) {
      roles.baseUrl = this.$store.state.settings.apiBaseUrl;
      const result = await people.getPersonEntities(id);
      this.$nextTick(() => {
        // eslint-disable-next-line prefer-destructuring
        this.selectedEntities = result[1].entities;
      });
    },
    async getDates() {
      parameters.baseUrl = this.$store.state.settings.apiBaseUrl;
      let startDateResult = [null, null];
      startDateResult = await parameters.getParameter('START_DATE');
      this.$nextTick(() => {
        if (startDateResult[1] != null) {
          // eslint-disable-next-line prefer-destructuring
          const m = moment(startDateResult[1].title);
          if (m.isValid()) this.startDate = m;
        }
        if (this.startDate != null) {
          if (moment().isSameOrAfter(this.startDate, 'day')) {
            if (!this.needVerification) this.needVerification = this.startDate.isAfter(this.$store.getters['authorization/data'].modified);
          }
        }
      });
    },
    showModal() {
      this.$bvModal.show('user-modal');
    },
    closeModal() {
      this.$bvModal.hide('user-modal');
    },
    update(user) {
      this.form.id = user.id;
      this.form.domain = user.domain;
      this.form.login = user.login;
      this.form.lastName = user.lastName;
      this.form.firstName = user.firstName;
      this.form.street = user.street;
      this.form.number = user.number;
      this.form.poBox = user.poBox;
      this.form.zip = user.zip;
      this.form.city = user.city;
      this.form.isoCountryCode = user.isoCountryCode;
      this.form.country = user.country;
      this.form.phone = user.phone;
      this.form.mobile = user.mobile;
      this.form.email = user.email;
      this.form.birthdate = user.birthdate;
      this.form.expenseType = user.expenseType;
      this.form.expenseTypeNavigation = user.expenseTypeNavigation;
      if (user.volunteer) {
        this.form.nationalNumber = user.nationalNumber;
        this.form.bankAccount = user.bankAccount;
      } else {
        this.form.nationalNumber = null;
        this.form.bankAccount = null;
      }
      this.form.created = user.created;
      this.form.modified = user.modified;
      this.form.volunteer = user.volunteer;
      this.form.isOver = user.isOver;
      this.form.needVerification = user.needVerification;
      this.form.exceedTotalKm = user.exceedTotalKm;
      this.form.exceedFeeCap = user.exceedFeeCap;
      this.selectedEntities = user.entities;
      this.selectedRoles = user.personRoles.map((elem) => ({
        id: elem.role.id,
        name: elem.role.name,
        key: elem.role.key,
      }));

      this.showModal();
    },
  },
};

</script>
